import { render, staticRenderFns } from "./ImgModal.vue?vue&type=template&id=0da2b31a&scoped=true&"
import script from "./ImgModal.vue?vue&type=script&lang=js&"
export * from "./ImgModal.vue?vue&type=script&lang=js&"
import style0 from "./ImgModal.vue?vue&type=style&index=0&id=0da2b31a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2b31a",
  null
  
)

export default component.exports